<template>
	<div>
		<!-- <HomeFirst></HomeFirst> -->
		<NavigationCard topHoverUrl="./../../assets/img/TopFirst/homeCenter.png" topUrl="../../../assets/img/TopFirst/HomeTop.mp4" topUrlType="video" />
		<HomeSecond></HomeSecond>
		<HomeFourth></HomeFourth>
	</div>
</template>

<script>
// import HomeFirst from '@/components/home/HomeFirst.vue';
import NavigationCard from '@/components/common/TopVideo.vue';
import HomeSecond from '@/components/home/HomeSecond.vue';
import HomeFourth from '@/components/home/HomeFourth.vue';
export default {
	name: 'HomePage',
	components: {
		// HomeFirst, HomeSecond, HomeFourth
		NavigationCard, HomeSecond, HomeFourth
	}
};
</script>

<style scoped></style>
